import React__default from 'react';
import { H4, P2, H3 } from '@zooplus/ui-components';
import { useTranslation } from '../../../hooks/use-translations.js';
import { formatMoney } from '../../../utils/utils.js';
import { Savings } from '../../common/savings/Savings.js';
import styles from './Summary.module.scss.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/gen/lang.js';
import { useSiteContext } from '../../../node_modules/@zooplus/commons-lang/dist/es/components/SiteProvider.js';
import '../../../node_modules/@zooplus/commons-lang/dist/es/hooks/use-translation.js';

const Summary = (props) => {
    const { site, locale } = useSiteContext();
    const { t } = useTranslation(site.realm);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { className: styles.wrapper },
            React__default.createElement(H4, { className: styles.total }, t('checkout.common.total')),
            React__default.createElement(P2, { className: styles.taxes }, t('checkout.common.taxes')),
            React__default.createElement(H3, { className: styles.amount }, formatMoney(props.total, props.currency, locale))),
        props.interval && React__default.createElement(Savings, { savedMoney: props.savedMoney, currency: props.currency, interval: props.interval })));
};

export { Summary };
//# sourceMappingURL=Summary.js.map
